import { useColumns } from '~/modules/common/components/ListTable';
import { useHasFeatureFlag } from '~/modules/common/hooks';
import { getFormatters } from '../renderers';
import { buildColumns } from './columns';

const applyPropOverrides = (columns, propOverrides) =>
  Object.keys(propOverrides).reduce((acc, columnId) => {
    if (!acc[columnId]) {
      return acc;
    }

    const overrides = propOverrides[columnId];
    const mergedClassName = overrides.className
      ? [acc[columnId].className, overrides.className].filter(Boolean).join(' ')
      : acc[columnId].className;

    return {
      ...acc,
      [columnId]: {
        ...acc[columnId],
        ...overrides,
        className: mergedClassName
      }
    };
  }, columns);

export const useListColumns = ({
  columnRenderOverrides,
  columnPropOverrides,
  ...props
}) => {
  const isPsaPrpTcopEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPrpTcopEnabled'
  });

  const baseRenders = getFormatters(props);
  const renders =
    isPsaPrpTcopEnabled && columnRenderOverrides
      ? { ...baseRenders, ...columnRenderOverrides }
      : baseRenders;

  const baseColumns = buildColumns(props);
  const columns =
    isPsaPrpTcopEnabled && columnPropOverrides
      ? applyPropOverrides(baseColumns, columnPropOverrides)
      : baseColumns;

  return useColumns({ columns, renders });
};
